import { Grid } from "@mui/material";
import type { FC } from "react";
import DatePickerComponent from "../datePicker/DatePicker";

interface DatePickerProps {
  readonly label: string;
  readonly value: string;
  readonly disabled?: boolean;
  readonly onChange: (value: string) => void;
}

const DatePicker: FC<DatePickerProps> = ({ label, value, disabled, onChange }) => (
  <DatePickerComponent label={label} size="small" disabled={disabled} fullWidth value={value} onChange={onChange} />
);

interface Props {
  readonly startDate: string;
  readonly endDate: string;
  readonly disabled?: boolean;
  readonly onStartDateChange: (date: string) => void;
  readonly onEndDateChange: (date: string) => void;
}

const DateRangePicker: FC<Props> = ({ startDate, endDate, disabled, onStartDateChange, onEndDateChange }) => {
  return (
    <Grid container data-testid="date-range-picker" spacing={2}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <DatePicker
          label="Data początkowa"
          value={startDate}
          disabled={disabled}
          onChange={(v) => onStartDateChange(v)}
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <DatePicker label="Data końcowa" value={endDate} disabled={disabled} onChange={(v) => onEndDateChange(v)} />
      </Grid>
    </Grid>
  );
};

export default DateRangePicker;
